/*  Данные редиректы используются ВМЕСТО типичных редиректов на заглушку из promo.json
    в случае, если нужна более тонкая настройка редиректа страниц в /pages
    (редирект на главную страницу с учётом языка ленда и пр.).

    В качестве deadline указывается СЛЕДУЮЩИЙ день после последнего дня акции
    (т.е. если акция по 20.02.2022 - то указывается 21.02.2022)
*/

export const promoOptions = {
  superdep: {
    deadline: 'Jul 15 2022'
  },
  all_stars: {
    deadline: 'Jun 30, 2022'
  },
  Spin_Mania: {
    deadline: 'May 30, 2022'
  },
  Richy_Rabbit: {
    deadline: 'May 30, 2022'
  },
  freebet_for_app: {
    deadline: 'Dec 27, 2022'
  },
  moneybox: {
    deadline: 'May 23, 2022'
  },
  lucky_xpress: {
    deadline: 'Jul 20, 2022'
  },
  football_bet: {
    deadline: 'May 01, 2022'
  },
  formula1: {
    deadline: 'Mar 21, 2022'
  },
  happy_hockey: {
    deadline: 'Jan 20, 2022'
  },
  happysport: {
    deadline: 'Jan 20, 2022'
  },
  olympics: {
    deadline: 'Feb 21, 2022'
  },
  freexpress: {
    deadline: 'Aug 09, 2022'
  },
  FridayCash: {
    deadline: 'Nov 26, 2022'
  },
  luckyzero: {
    deadline: 'Jan 01, 2023'
  },
  championseries: {
    deadline: 'Dec 27, 2022'
  },
  prediction_battle: {
    deadline: 'Dec 27, 2022'
  },
  ny_moneybox: {
    deadline: 'Jan 14, 2023'
  }
}